export const urlValidationRule = {
    url: {
        url: {
            message: '^Provide a valid URL',
        },
    },
};

export function getDataTrend(currentValue?: number, comparedTo?: number) {
    if (currentValue === undefined && comparedTo === undefined) {
        return 'no_data';
    } else if (currentValue === undefined || comparedTo === undefined) {
        return 'equal';
    } else if (currentValue > comparedTo) {
        return 'increased';
    } else if (currentValue < comparedTo) {
        return 'decreased';
    } else {
        return 'equal';
    }
}
